@use "Styles/mixins" as mixins;

:host {
    position: relative;
    display: block;
    width: 70vw;
    height: 70vw;
    max-width: 500px;
    max-height: 500px;

    &::after {
        content: " ";
        position: absolute;
        bottom: 0;
        right: 0;
        width: 200px;
        height: 100px;
        background-color: mixins.get-color(bg, solid, primary);
    }
}
